import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SideBar from './SideBar';
import { actions } from './SideBar.actions';
import storage from '../../higherOrder/storage';

const SideBarComponent = connect(
    function mapStateToProps(state) {
        return {
            isNavExtended: state.isNavExtended,
        };
    },
    null
)(SideBar);

// Wrapper component to provide location
const SideBarWithLocation = (props) => {
    const location = useLocation();
    return <SideBarComponent {...props} location={location.pathname} />;
};

export default storage(SideBarWithLocation, 'sidebar', { isOpen: false });